import { Component, Input, OnInit } from '@angular/core';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { AssetModel } from 'src/app/property/models/new-asset.model';
import { ActivatedRoute } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AssetMaintenanceCycleType, AssetMaintenanceCycleTypeOptions } from 'src/app/property/constants/asset-maintenance-cycle.enum';
import { ButtonAction } from '../../models/action-button.model';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { AssetStatusCategories } from 'src/app/asset/models/asset.model';
import { AssetCacheService } from '../../services/asset-detail/job-cache.service';

@Component({
  selector: 'app-asset-detail',
  templateUrl: './asset-detail.component.html',
  styleUrls: ['./asset-detail.component.scss']
})
export class AssetDetailComponent implements OnInit {
  
  private assetCategory;  
  public isShowSendToTenant = true; 
  public showSendToTenantTag : boolean;
  public showTenantCompletedTag : boolean;
  public showNeedToBeApprovedTag : boolean;
  public showDuplicatedTag : boolean;
  selectedMatTabIndex = 0;
  openAssetEditDrawer:boolean=false;
  asset : AssetModel;
  isResponseLoading: boolean = false;

  public assetId; 
  @Input() selectedAssetId : string;
  @Input() displayAtTop : boolean = false;
  @Input() hideButtons : boolean = false;
  @Input() assetIdFromParent : boolean;
  @Input() assetStatus : string;
  @Input() isWizard;  
  @Input() set assetData(asset: any) {
    if (!asset)
      return;
    this.asset = asset;
  }
  @Input() set assetDataID(assetId: any) {
    if (!assetId)
      return;
    this.assetIdFromParent = true;
    this.getAssetDetails(assetId);
  }
  
  
  constructor(private assetService: AssetService, private route: ActivatedRoute, private bottomSheet: MatBottomSheet, private toaster: TosterService,  private uiContext: AssetCacheService,) { 
    if(!this.assetIdFromParent){
      this.route.paramMap.subscribe({
        next: (paramMap) => {
          this.assetId = paramMap.get('id');
          this.isWizard = paramMap.get('isWizard') == 'wizard';
          this.assetCategory = paramMap.get('assetCategory');
          this.assetStatus =this.assetCategory;
          this.setAssetTags(this.assetCategory);
        },
      });
    }
  }

  ngOnInit(): void {
    if(!this.isWizard){
      this.setAssetTags(this.assetStatus);
      this.assetId = this.assetId ?? this.selectedAssetId;
    }

    if(!this.displayAtTop && (this.assetStatus == AssetStatusCategories[AssetStatusCategories.Duplicated] || this.assetCategory == AssetStatusCategories[AssetStatusCategories.Duplicated])){
      this.showDuplicatedTag = true;
    }

    if((this.assetId?.length > 0 || this.selectedAssetId) && !this.assetIdFromParent){
      this.getAssetDetails(this.assetId ?? this.selectedAssetId);   
    }
  }

  maintenanceCycleLabel(maintenanceCycle: AssetMaintenanceCycleType) {
    return typeof maintenanceCycle === 'number' && !isNaN(maintenanceCycle)
        ? AssetMaintenanceCycleTypeOptions.find(elem => elem.key == maintenanceCycle)?.value || ''
        : '';
  }

  getAssetDetails(assetId: string) {
    if(!assetId) return;
    this.isResponseLoading = true;
    this.assetService.details(assetId, this.uiContext.currentVersion).subscribe({
      next: (res) => {
        this.asset = res;
        this.isResponseLoading = false;

          if(this.asset?.isVacantProperty){
            this.isShowSendToTenant = false;
          } else if(this.assetCategory != AssetStatusCategories[AssetStatusCategories.TenantCompleted]){
            this.isShowSendToTenant = true;
          }
        }
    })
  }

  onActionButtonClick(event : ButtonAction){
    if (event === ButtonAction.Edit) {
      this.openEditDrawer();
    }
  }

  openEditDrawer(){
    this.openAssetEditDrawer =true;
  }

  closeEditAssetDrawer(refreshAssetList: boolean){
    this.openAssetEditDrawer =false;
    if(refreshAssetList){
      this.getAssetDetails(this.assetId); 
    }
  }

  private setAssetTags(category: string): void {
    switch (category) {
      case AssetStatusCategories[AssetStatusCategories.NeedToBeApproved]:
        this.showNeedToBeApprovedTag = true;
        break;
      case AssetStatusCategories[AssetStatusCategories.SentToTenant]:
        this.showSendToTenantTag = true;
        break;
      default:
        break;
    }
  }

}
